{
  "es": {
    "inspiration": {
      "actions": {
        "delete": "Eliminar",
        "deleteMultipleInspirations": "Eliminar...",
        "delete_cancel": "Deshacer eliminación",
        "goBackToInspirationLists": "Inspiración",
        "new": "Añadir foto"
      },
      "labels": {
        "move_to_upload": "Coloca las fotos en el recuadro de abajo o haz clic para subirlas.",
        "noInspirations": "Aún no hay inspiraciones",
        "upload_autoclose": "Esta ventana se cerrará automáticamente cuando se hayan subido todas las fotos."
      },
      "toasts": {
        "upload_success": "{count} inspiración subida correctamente | {count} inspiraciones subidas correctamente"
      }
    }
  }
}
